import { http } from '@pendo/http';

export function getOnboardingV1 () {
    return http.get('api/s/_SID_/userjourneytask/user/_UID_/task/onboardingV1');
}

export function markOnboardingV1Complete () {
    return http.put('api/s/_SID_/userjourneytask/user/_UID_/task/onboardingV1/complete', { set: true });
}
